var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalCountries(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.5C11.3661 14.5 14.5 11.3661 14.5 7.5C14.5 3.6339 11.3661 0.5 7.5 0.5C3.6339 0.5 0.5 3.6339 0.5 7.5C0.5 11.3661 3.6339 14.5 7.5 14.5Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.39401C1.55537 5.89584 2.33587 5.82642 2.8415 6.18576C3.59995 6.72476 3.6948 8.92241 5.4203 7.87241C7.1458 6.82241 4.68145 6.39401 5.21625 4.87291C5.75105 3.35146 7.5028 4.53341 7.67675 2.86706C7.79318 1.75616 6.46435 1.33102 3.69025 1.59166",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6999 1.89999C9.70003 3.64603 9.00154 4.70034 9.60448 5.06294C10.5089 5.60719 10.8925 4.84104 11.9964 5.06294C13.1003 5.28484 12.8609 6.78109 12.2806 6.78109C11.7003 6.78109 8.69343 6.39819 8.84498 8.15274C8.99653 9.90729 10.805 10.167 10.805 11.1473C10.805 11.8007 10.4048 12.8009 9.60448 14.1479M1.23633 10.6241C1.47491 10.5191 1.71479 10.4171 1.95593 10.3182C3.30226 9.77453 4.3014 9.64631 4.95333 9.93354C6.10553 10.4421 5.66243 11.469 6.02363 11.8473C6.38413 12.2257 7.28573 12.1158 7.28573 12.8354C7.28573 13.3154 7.12449 13.8574 6.80203 14.4615",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCountries);
export default __webpack_public_path__ + "static/media/TotalCountries.0b44fbe4b3003a8ea1ad3a152fe83b7a.svg";
export { ForwardRef as ReactComponent };